import React, { useContext } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from '@oneaudi/feature-app-utils';
import { IconButton } from '@oneaudi/unified-web-components';
import { IconButton as IconButtonAlpha } from '@oneaudi/unified-web-alpha-components';
import { FAStateContext } from '../context/FAStateContext';
import { ContentContext } from '../context/ContentContext';
import { UniversalStateContext } from '../context/UniversalStateContext';

export const Container = styled.div<{ stageConfigBtn?: boolean }>`
  position: absolute;
  display: flex;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.sysColorSurfaceNeutral800WithOpacity};
  height: 36px;
  z-index: 5;
  top: ${({ theme }) => theme.spacing.sysSpaceFixed300};
  ${({ stageConfigBtn }) =>
    stageConfigBtn ? `right: var(--page-margin);` : `left: var(--page-margin);`}

  @media (min-width: ${(props) => props.theme.breakpoints.md}px) {
    top: ${({ theme }) => theme.spacing.sysSpaceFixed350};
    height: 48px;
  }
  @media (min-width: ${(props) => props.theme.breakpoints.xl}px) {
    top: auto;
    bottom: 36px;
    justify-content: center;
  }
`;

const StyledButton = styled(IconButton)<{ selected: boolean }>`
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.globalColorElevationLevel1 : 'transparent'};
  border-radius: 24px;
`;

const StyledButtonAlpha = styled(IconButtonAlpha)<{ selected: boolean }>`
  background-color: ${({ theme, selected }) =>
    selected ? theme.colors.globalColorElevationLevel1 : 'transparent'};
  border-radius: 24px;
`;

export const SliderViewModeSwitch: React.FC = () => {
  const { viewMode, setViewMode } = useContext(FAStateContext);
  const content = useContext(ContentContext);
  const {
    streamDisplayOption: { show3dStream },
  } = content;
  if (!show3dStream || !viewMode) {
    return null;
  }
  const { i18nTexts } = useContext(UniversalStateContext)!;
  const ariaSlides = i18nTexts['ariaLabel.imageViewMode'] ?? 'Show photo gallery';
  const aria3D = i18nTexts['ariaLabel.3dViewMode'] ?? 'Show 360° view';
  const isMobile = useMediaQuery('(max-width: 767px)');
  const buttonSize = isMobile ? 'sm' : 'md';
  const buttonSizeAlpha = isMobile ? 'xs' : 'md';

  return (
    <Container>
      {process.env.IS_LEGACY ? (
        <>
          <StyledButton
            icon="photo"
            selected={viewMode === 'slides'}
            onClick={() => setViewMode('slides')}
            aria-label={ariaSlides}
            size={buttonSize}
            variant="tertiary"
          />
          <StyledButton
            icon="3d"
            selected={viewMode === '3dStream'}
            onClick={() => setViewMode('3dStream')}
            aria-label={aria3D}
            size={buttonSize}
            variant="tertiary"
          />
        </>
      ) : (
        <>
          <StyledButtonAlpha
            icon="photo"
            selected={viewMode === 'slides'}
            onClick={() => setViewMode('slides')}
            aria-label={ariaSlides}
            size={buttonSizeAlpha}
            variant="tertiary"
          />
          <StyledButtonAlpha
            icon="3d"
            selected={viewMode === '3dStream'}
            onClick={() => setViewMode('3dStream')}
            aria-label={aria3D}
            size={buttonSizeAlpha}
            variant="tertiary"
          />
        </>
      )}
    </Container>
  );
};
